import { Typography } from "@material-ui/core";
import styled from "styled-components/macro";
import { color } from "../../../../styles/style";

export const SectionTitle = styled(Typography)`
  margin-bottom: 1rem;
  color: ${color.dark};
`;
